<template>
    <footer class="w-full bg-gray-200 p-2 pl-6 pr-6 h-auto lg:h-10 flex flex-wrap z-40 text-xs margin-top-footer place-content-center shadow-md">
        <span v-text="copy_right_text" class="self-center text-gray-400 font-semibold"/>
        <div class="grow xs:hidden" />
        <div class="space-x-5 self-center cursor-pointer text-gray-400 justify-center items-center text-center">
            <span v-for="(item,index) in clickables" :id="item+index" :key="index" v-text="item" @click="clicked(item)" class="hover:underline"/>
        </div>
    </footer>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
    props:{
        copy_right_text:{
            type:String,
            required:true,
        },
        clickables:{
            type:Array,
            required:false,
        }
    },
    data(){
        return {
            version:'2.01.55'
        }
    },
    methods:{
        clicked(item) {
            this.$emit('clicked',item);
        }
    }
})
</script>
<style scoped>
.margin-top-footer {
    bottom:0 !important;
}
</style>
